import Logo from '@/components/Logo/Logo'
import { createFileRoute } from '@tanstack/react-router'
import type { LucideIcon } from 'lucide-react'
import { CRT_ROUTES, toStaticData } from './crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt')({
  staticData: { ...toStaticData(CRT_ROUTES['/crt']), icon: Logo as unknown as LucideIcon },
  beforeLoad: async ({ context }) => {
    context.assertModuleAccess('crt')
    context.handleRoutePermissions(Route)
  },
})
